<div id="txtdata1"  class="card-header">
  <h4 class="card-title">{{'basicdata.user.title' | translate}} </h4>
</div>
<fieldset >

<!-- <div class="">
  <div class="input-group">
    <input type="text" class="form-control" (change)="userSearch(t.value,page)" placeholder="{{'basicdata.searchuser' | translate}}  " [(ngModel)]="searchString" #t>


    <div class="input-group-append">
      <button class="btn btn-search" type="button" (click)="userSearch(searchString,page)">
        <i class="ik ik-search"></i></button>
      <button class="btn btn-search" type="button" (click)="SearchUsers(t.value,page)"><i
          class="ik ik-search"></i></button>
    </div>

  </div>
</div> -->

<div [attr.disabled]="true"  class="row">
  <div class=" col-lg-6 col-md-6 col-sm-12">
    <mat-form-field appearance="fill">
      <mat-label>{{'basicdata.user.searchuser' | translate}}</mat-label>
      <input appPermission  id="txtdata2" matInput #t>
    </mat-form-field>
  </div>
  <div class=" col-lg-3 col-md-6 col-sm-12">
    <mat-form-field appearance="fill">
      <mat-label>{{'basicdata.user.role' | translate}}</mat-label>
      <mat-select appPermission id="txtdata3"    #roleId [(ngModel)]="selectedRole">
        <mat-option *ngFor="let role of roles" value="{{role.id}}">{{role.name}}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  
  <div class=" col-lg-3 col-md-6 col-sm-12">

  <button    mat-raised-button color="primary" (click)="SearchUsers(t.value,roleId.value)">
    <i class="fas fa-search"></i></button>
</div>
</div>

<!--
  <div class="table-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          <th>{{'basicdata.user.name' | translate}}</th>
          <th>{{'basicdata.user.mail' | translate}} </th>
          <th>{{'basicdata.user.role' | translate}} </th>
        </tr>
      </thead>
      <tbody>
  
         <tr>
          <td> محمد محمد احمد </td>
          <td> so@mail.com</td>
          <td>
              <div class="d-flex justify-content-center role-btns">
            <div class=" btn-group-toggle">
                <label class="btn-primary btn-block" ngbButtonLabel>
                  <input type="checkbox" ngbButton [(ngModel)]="model.admin" > {{'basicdata.user.admin' | translate}}
                </label>
              </div>

              <div class=" btn-group-toggle">
                <label class="btn-primary btn-block" ngbButtonLabel>
                  <input type="checkbox" ngbButton [(ngModel)]="model.patient" > {{'basicdata.user.patient' | translate}}
                </label>
              </div>

              <div class=" btn-group-toggle">
                <label class="btn-primary btn-block" ngbButtonLabel>
                  <input type="checkbox" ngbButton [(ngModel)]="model.nurse" > {{'basicdata.user.nurse' | translate}}
                </label>
              </div>

              <div class=" btn-group-toggle">
                <label class="btn-primary btn-block" ngbButtonLabel>
                  <input type="checkbox" ngbButton [(ngModel)]="model.receptionist" > {{'basicdata.user.receptionist' | translate}}
                </label>
              </div>
              </div>
          </td>
         </tr>
  
      </tbody>
  
  
    </table>
   
  </div>

-->
<div class="table-responsive">
  <div class="d-flex justify-content-center">
    <!--<button mat-raised-button class="table-action" [routerLink]="['/auth/basic-data/add-user']"color="primary"> <i class="fas fa-plus"></i> {{'admin.Adduser' | translate}}</button>-->
    <button mat-raised-button class="table-action" [routerLink]="['/auth/basic-data/import-user']" color="primary"> <i class="fas fa-upload"></i> {{'admin.usersimport' | translate}}</button>
  </div>
  <table class="table table-striped table-bordered" >
    <thead>
      <tr>
        <th>{{'basicdata.user.name' | translate}}</th>
        <th>{{'basicdata.user.mail' | translate}} </th>
        <th>{{'basicdata.user.role' | translate}} </th>
        <th>{{'basicdata.dateofregister' | translate}} </th>
        <th>{{'Users.Gender' | translate}} </th>
        <th>{{'basicdata.status' | translate}} </th>
        <th>{{'general.details' | translate}} </th>
      </tr>
    </thead>
    <tbody>

      <tr *ngFor="let user of userData">
        <td>{{user.userName}}</td>
        <td>{{user.email}}</td>
        <td>{{user.role}}</td>
        <td>{{user.registerationDate| date:'medium'}}</td>
        <td>{{user.gender}}</td>
        <td><mat-slide-toggle 
          [(ngModel)]="user.active"
          > </mat-slide-toggle> </td>
          <td>
            <button mat-raised-button class=" table-action3" (click)="openUserDetail(user)" color="primary"> 
              <i class="far fa-eye"></i>
          </button>
      </tr>
      

    </tbody>


  </table>
  
  <div class="d-flex justify-content-center upload-container">
    <button mat-raised-button 
    [hidden]="!clearSearch"
    class="table-action cancel" color="primary"
     (click)="cancelSearch()"><i class="far fa-times-circle"></i>{{'general.cancelSearch' | translate}}</button>
  </div>

  <div class="d-flex justify-content-center">
    <ngb-pagination (pageChange)="onPageChange($event)" [(page)]="page" [pageSize]="pageSize"
      [collectionSize]="userDataLength" [maxSize]="5"  [ellipses]="false" [boundaryLinks]="true" aria-label="Default pagination"></ngb-pagination>
  </div>
</div>
</fieldset>